import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';

import { setSelectedCampaign, setSelectedGroup } from '../../../../redux/Slices/deviceSlice';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { useAssignCampaignDevices } from '../../../../queries';
import { useState } from 'react';
import CampaignsList from './CampaignsList';

const IcPlus = () => <svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" /></svg>;
const IcClose = () => <svg width="18" height="18" viewBox="0 0 24 24" style={{ stroke: 'currentColor', fill: 'none', strokeWidth: 2 }}><path d="M6 6l12 12M18 6L6 18" /></svg>;

function GroupAssignCampaignsDropDown() {
    const { t } = useTranslation();
    const assignCampaignDevices = useAssignCampaignDevices();
    const { companyCampaigns, selectedCampaign, selectedGroup } = useSelector((state) => state.device);
    const { openDialog } = useSelector((state) => state.global);
    const dispatch = useDispatch();
    const [showOptions, setShowOptions] = useState(false)
    const [campaignName, setCampaignName] = useState()

    const assign = async () => {
        const data = {
            campaign_id: selectedCampaign,
            groups_ids: [selectedGroup.group_id],
            type: "groups",
        };

        await assignCampaignDevices.mutateAsync(data, {
            onSuccess: () => {
                const rejected = data?.rejected;
                if (rejected?.satellite?.length === 0) {
                    dispatch(toggleDialog("GroupAssignCampaignsDropDown"));
                }
                dispatch(setSelectedCampaign(""));
                dispatch(setSelectedGroup({}));
                dispatch(toggleDialog("GroupAssignCampaignsDropDown"));
            },
        });
    }

    const onClose = () => {
        dispatch(setSelectedGroup({}));
        dispatch(setSelectedCampaign(""));
        dispatch(toggleDialog("GroupAssignCampaignsDropDown"))
    }

    // useEffect(() => {
    //     const matchedCampaign = companyCampaigns.find(c => c.id === selectedCampaign);
    //     setCampaignName(matchedCampaign ? matchedCampaign.name : '');
    // }, [selectedCampaign])

    return (
        <>
            <Dialog visible={openDialog.GroupAssignCampaignsDropDown}
                style={{ width: '460px' }}
                breakpoints={{ '960px': '95vw' }}
                showHeader={false}
                modal className="pp-dlg"
                onHide={onClose}>

                <div className="pp-dlg-hd">
                    <span className="ic"><IcPlus /></span>
                    <div>
                        <div className="t">{t('devices.assign_campaign_to_group')}</div>
                        <div className="s">{t('devices.assign_group_label')}: {selectedGroup.name}</div>
                    </div>
                    <span className="x" onClick={onClose}><IcClose /></span>
                </div>

                <div className="pp-dlg-bd">
                    <div className="pp-dlg-fld">
                        <label>{t('devices.assign_campaigns_label')}</label>
                        <div
                            className='w-100 p-dropdown p-component p-inputwrapper'
                            onClick={() => showOptions ? setShowOptions(false) : setShowOptions(true)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className='p-dropdown-label p-inputtext'>
                                {campaignName || t('devices.assign_select_campaign')}
                            </div>
                            <div className='p-dropdown-trigger'>
                                <span className='p-dropdown-trigger-icon pi pi-chevron-down'></span>
                            </div>
                        </div>

                        {showOptions ? <CampaignsList setShowOptions={setShowOptions} onSelect={(item) => {
                            dispatch(setSelectedCampaign(item.id))
                            setCampaignName(item.name)

                        }} /> : null}
                    </div>
                </div>

                <div className="pp-dlg-ft">
                    <button className="btn primary" disabled={assignCampaignDevices.isLoading} onClick={assign}>{t('buttons.save')}</button>
                    <button className="btn ghost" disabled={assignCampaignDevices.isLoading} onClick={onClose}>{t('buttons.cancel')}</button>
                </div>
            </Dialog>
        </>
    )
}

export default GroupAssignCampaignsDropDown